// Character and token helpers for normalization scanner modules.
// Example: skipWhitespace("  var(--x)", 0) -> 2.

// Skip whitespace from index and return first non-space position.
export function skipWhitespace(input: string, fromIndex: number): number {
  let index = fromIndex
  // Advance while current character is whitespace.
  while (index < input.length && isWhitespace(input[index])) {
    index += 1
  }

  // Return first non-whitespace position.
  return index
}

// Detect identifier start characters for variable/property key parsing.
export function isIdentifierStart(char: string): boolean {
  // Return true when character can start identifier token.
  return (
    (char >= 'a' && char <= 'z')
    || (char >= 'A' && char <= 'Z')
    || char === '_'
  )
}

// Detect identifier continuation characters for variable/property key parsing.
export function isIdentifierChar(char: string): boolean {
  // Return true when character can continue identifier token.
  return isIdentifierStart(char) || (char >= '0' && char <= '9') || char === '-'
}

// Detect property name start characters for declaration parsing.
export function isPropertyNameStart(char: string): boolean {
  // Return true when character can start property token.
  return isIdentifierStart(char) || char === '-'
}

// Detect property name continuation characters for declaration parsing.
export function isPropertyNameChar(char: string): boolean {
  // Return true when character can continue property token.
  return isIdentifierChar(char)
}

// Detect whitespace characters used by the parser state machine.
export function isWhitespace(char: string): boolean {
  // Return true when character is scanner-recognized whitespace.
  return char === ' ' || char === '\t' || char === '\n' || char === '\r'
}
